/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import GoogleCalendar from './icon-google-calendar.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleCalendar {...validProps} />;
}
SvgComponent.iconName = 'googleCalendar';

export const GoogleCalendarIcon = svgIconWrapper(SvgComponent);
